import { createTheme } from "@mui/material/styles";
import { brand, figures, alpha } from "./palette";

const fontStack = ["Inter", "system-ui", "sans-serif"].join(",");
const titleStack = ["Poppins", "system-ui", "sans-serif"].join(",");

/**
 * Dark editorial: warm graphite + cream + dusty purple. Brand tokens come from
 * src/palette.js (the same source Tailwind uses) so MUI components (menus,
 * dialogs, buttons) feel native to the same brand.
 */
const secondaryDark = {
  main: brand.accentInv,
  dustyPurple40: alpha(brand.paper, 0.22),
  dustyPurple20: brand.accentInv,
  dustyPurple70: brand.surfaceLow,
  lightgrey: brand.bodyInv,
};

/** Editorial light: reuse token names so --dusty-purple-* CSS vars stay meaningful in App.css */
const secondaryLight = {
  main: brand.accent,
  dustyPurple40: alpha(brand.display, 0.22),
  dustyPurple20: brand.accent,
  dustyPurple70: "#ebe4d8",
  lightgrey: "#ebe4d8",
};

/**
 * MUI theme aligned with ColorThemeProvider (`light` | `dark`).
 * Keeps custom palette keys used by ThemeVariables / CSS variables.
 */
export function createBiosTheme(siteMode) {
  const isDark = siteMode === "dark";

  return createTheme({
    palette: {
      mode: isDark ? "dark" : "light",
      primary: {
        main: isDark ? brand.accentInv : brand.accent,
        white: "#ffffff",
        black: "#000210",
        bgColor: isDark ? brand.surface : brand.paper,
        yellow: "#FBBD00",
      },
      secondary: isDark ? secondaryDark : secondaryLight,
      background: {
        default: isDark ? brand.bg : brand.paper,
        paper: isDark ? brand.surface : figures.wash,
      },
      text: {
        primary: isDark ? brand.displayInv : brand.display,
        secondary: isDark ? brand.mutedInv : brand.muted,
      },
      divider: isDark ? alpha(brand.paper, 0.1) : alpha(brand.display, 0.12),
    },
    typography: {
      fontFamily: fontStack,
      h1: { fontFamily: titleStack },
      h2: { fontFamily: titleStack },
      h3: { fontFamily: titleStack },
      h4: { fontFamily: titleStack },
      h5: { fontFamily: titleStack },
      h6: { fontFamily: titleStack },
    },
    components: {
      // Solid editorial paper/graphite popups — no backdrop blur.
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: isDark ? brand.surface : figures.wash,
          },
        },
      },
    },
  });
}

export default createBiosTheme("light");
